import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  // Always shown after submit, regardless of whether the email exists -
  // the server response is deliberately the same either way, and the UI
  // shouldn't undo that by branching on success/failure differently here.
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError("");
    setSubmitting(true);
    try {
      await axios.post(
        `${API_BASE_URL}/auth/forgot-password`,
        { email }
      );
      setSubmitted(true);
    } catch (err) {
      setError(
        err.response?.data || "Something went wrong. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-paper">
      <div className="bg-card border border-line p-8 rounded-lg w-96">
        <h2 className="text-xl font-semibold mb-4 text-ink">Forgot password</h2>
        {submitted ? (
          <p className="text-sub text-sm">
            If an account exists for that email, a reset link has been sent.
            Check your inbox.
          </p>
        ) : (
          <form onSubmit={handleSubmit}>
            <p className="text-sub text-sm mb-4">
              Enter the email on your account and we'll send a link to reset
              your password.
            </p>
            {error && (
              <p className="text-primary text-sm mb-3">{error}</p>
            )}
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border border-line p-2 w-full mb-4 rounded focus:ring focus:ring-primary/30"
              required
            />
            <button
              type="submit"
              disabled={submitting}
              className="bg-primary text-white p-2 w-full rounded hover:opacity-90 transition disabled:opacity-50"
            >
              {submitting ? "Sending..." : "Send reset link"}
            </button>
          </form>
        )}
        <Link
          to="/login"
          className="block text-center text-sm text-primary mt-4 hover:underline"
        >
          Back to login
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
